import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MdClose, MdEdit, MdChevronLeft, MdChevronRight } from "react-icons/md";
import axios from "axios";
import CustomerTable from "./CustomerTable";

const RecordingHistory = ({ recordingId }) => {
  
  const [error, setError] = useState(null);

  const callsPerPage = 8;

  

  

  return (
    <div className="  bg-gray-50 ">
      {/* <h1 className="text-3xl font-bold mb-8 text-gray-800 text-center">
      Recording Call History
      </h1> */}

      {error && (
        <div className="mb-6 p-4 bg-red-50 text-red-600 rounded-lg flex justify-between items-center shadow-sm">
          <span>{error}</span>
          <button onClick={() => setError(null)} className="text-red-800">
            <MdClose />
          </button>
        </div>
      )}

      {/* Table */}
  
      <CustomerTable
              
            />




    </div>
  );
};

export default RecordingHistory;